import { isBenchType, Machine } from "./Machine";
import { ProgressionState } from "./GameState";
import { availableOperations } from "./skill-helpers";

/**
 * Whether this station has a sheet worth opening. Benches and containers
 * always do; a direct-feed machine only does if there is an accessory slot to fit
 * something into, since everything else about running it lives on the
 * floor. Machines with no sheet leave the key unbound rather than opening
 * an empty page.
 */
export function hasStationSheet(machine: Machine): boolean {
  return machine.type.directFeed ? machine.toolSlots > 0 : true;
}

/**
 * Whether E (or a right-click) at this station leans the player over a
 * work surface rather than spreading a sheet. A bench with work to do
 * does: its plans, tools, and racks hang on the bench's own chrome. A
 * container bench — a garbage can, a lumber rack — has no work surface,
 * so its sheet stays the inventory it always was.
 */
export function divesToBench(
  machine: Machine,
  progression: ProgressionState,
): boolean {
  return (
    isBenchType(machine.type) &&
    !machine.type.container &&
    availableOperations(machine, progression).length > 0
  );
}
